const keyForLesson = (lessonId) => `lh_deleted_lesson_contents:${lessonId || ""}`;

export const getDeletedLessonContentIds = (lessonId) => {
  if (!lessonId) return [];

  try {
    const raw = localStorage.getItem(keyForLesson(lessonId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id) => typeof id === "string" && id.length > 0);
  } catch {
    return [];
  }
};

export const rememberDeletedLessonContentId = (lessonId, contentId) => {
  if (!lessonId || !contentId) return;

  const prev = getDeletedLessonContentIds(lessonId);
  if (prev.includes(contentId)) return;

  const next = [...prev, contentId];
  localStorage.setItem(keyForLesson(lessonId), JSON.stringify(next));
};
